import Vue from "vue";
import VueI18n from "vue-i18n";
import ko from "./locales/ko.json";
import en from "./locales/en.json";
// import ch from "./locales/ch.json";

const locales = {
  ko,
  en,
  // ch
};

Vue.use(VueI18n);
function loadLocaleMessages() {
  // const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  for (let [key, value] of Object.entries(locales)) {
    // locales.keys().forEach((key) => {
    messages[key] = value;
  }
  return messages;
}

export default new VueI18n({
  locale: "ko",
  fallbackLocale: "ko",
  silentFallbackWarn: true,
  messages: loadLocaleMessages(),
});
